import script from "./TimeslotDeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeslotDeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./TimeslotDeleteModal.vue?vue&type=style&index=0&id=66ce3be7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66ce3be7"]])

export default __exports__